import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
var store = configureStore({
    reducer: rootReducer,
    middleware: function (getDefaultMiddleware) { return getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false,
    }); },
});
export default store;
//# sourceMappingURL=store.js.map